// 2021 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-24)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2021-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2021-masterwork",
//     name: "2021 Topps Star Wars Masterwork",
//     shortName: "Masterwork 2021",
//     year: 2021,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2021",
//     totalCards: 429,
//     description: "Topps 2021 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2021-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "Aayla Secura" },
        { n: "2", name: "Admiral Ackbar" },
        { n: "3", name: "Admiral Holdo" },
        { n: "4", name: "Ahsoka Tano" },
        { n: "5", name: "Allegiant General Pryde" },
        { n: "6", name: "Anakin Skywalker" },
        { n: "7", name: "Asajj Ventress" },
        { n: "8", name: "Aurra Sing" },
        { n: "9", name: "Bantha" },
        { n: "10", name: "Baze Malbus" },
        { n: "11", name: "BB-8" },
        { n: "12", name: "Beckett" },
        { n: "13", name: "Bib Fortuna" },
        { n: "14", name: "Burg" },
        { n: "15", name: "Boba Fett" },
        { n: "16", name: "Bodhi Rook" },
        { n: "17", name: "Bo-Katan Kryze" },
        { n: "18", name: "Boss Nass" },
        { n: "19", name: "Bossk" },
        { n: "20", name: "C-3PO" },
        { n: "21", name: "Cad Bane" },
        { n: "22", name: "Captain Phasma" },
        { n: "23", name: "Captain Cassian Andor" },
        { n: "24", name: "Chewbacca" },
        { n: "25", name: "Chirrut Imwe" },
        { n: "26", name: "Cobb Vanth" },
        { n: "27", name: "Count Dooku" },
        { n: "28", name: "Darth Maul" },
        { n: "29", name: "Darth Vader" },
        { n: "30", name: "Dewback" },
        { n: "31", name: "Dryden Vos" },
        { n: "32", name: "Emperor Palpatine" },
        { n: "33", name: "Enfys Nest" },
        { n: "34", name: "Ezra Bridger" },
        { n: "35", name: "Fennec Shand" },
        { n: "36", name: "Finn" },
        { n: "37", name: "Frog Lady" },
        { n: "38", name: "Galen Erso" },
        { n: "39", name: "General Grievous" },
        { n: "40", name: "General Hux" },
        { n: "41", name: "Grand Admiral Thrawn" },
        { n: "42", name: "Grand Moff Tarkin" },
        { n: "43", name: "Greedo" },
        { n: "44", name: "Greef Karga" },
        { n: "45", name: "Grogu" },
        { n: "46", name: "Han Solo" },
        { n: "47", name: "Hera Syndulla" },
        { n: "48", name: "IG-11" },
        { n: "49", name: "IG-88" },
        { n: "50", name: "Jabba The Hutt" },
        { n: "51", name: "Jango Fett" },
        { n: "52", name: "Jannah" },
        { n: "53", name: "Jar Jar Binks" },
        { n: "54", name: "Jedi Master Mace Windu" },
        { n: "55", name: "Jedi Master Yoda" },
        { n: "56", name: "Jyn Erso" },
        { n: "57", name: "K-2SO" },
        { n: "58", name: "Kaadu" },
        { n: "59", name: "Kanan Jarrus" },
        { n: "60", name: "Kit Fisto" },
        { n: "61", name: "Trudgen" },
        { n: "62", name: "Krayt Dragon" },
        { n: "63", name: "Kuiil" },
        { n: "64", name: "Kylo Ren" },
        { n: "65", name: "L3-37" },
        { n: "66", name: "Lady Proxima" },
        { n: "67", name: "Lando Calrissian" },
        { n: "68", name: "Lieutenant Connix" },
        { n: "69", name: "Luke Skywalker" },
        { n: "70", name: "Mandalorian" },
        { n: "71", name: "Maz Kanata" },
        { n: "72", name: "Moff Gideon" },
        { n: "73", name: "Mon Mothma" },
        { n: "74", name: "Koska Reeves" },
        { n: "75", name: "Obi-Wan Kenobi" },
        { n: "76", name: "Orson Krennic" },
        { n: "77", name: "Padmé Amidala" },
        { n: "78", name: "Poe Dameron" },
        { n: "79", name: "Princess Leia Organa" },
        { n: "80", name: "Mayfeld" },
        { n: "81", name: "Qi'ra" },
        { n: "82", name: "Qui-Gon Jinn" },
        { n: "83", name: "R2-D2" },
        { n: "84", name: "Rey" },
        { n: "85", name: "Rose Tico" },
        { n: "86", name: "Sabine Wren" },
        { n: "87", name: "Gor Koresh" },
        { n: "88", name: "Satine Kryze" },
        { n: "89", name: "Saw Guerrera" },
        { n: "90", name: "Sebulba" },
        { n: "91", name: "Senator Bail Organa" },
        { n: "92", name: "Shmi Skywalker" },
        { n: "93", name: "Supreme Leader Snoke" },
        { n: "94", name: "Tauntaun" },
        { n: "95", name: "The Rancor" },
        { n: "96", name: "Varactyl" },
        { n: "97", name: "Watto" },
        { n: "98", name: "Wedge Antilles" },
        { n: "99", name: "Zam Wesell" },
        { n: "100", name: "Zorii Bliss" },
    ],
  },
  {
    id: "manufactured-character-medallion-cards",
    type: "insert",
    title: "MANUFACTURED CHARACTER MEDALLION CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CM-C3C", name: "C-3PO" },
        { n: "CM-C3R", name: "C-3PO" },
        { n: "CM-CC", name: "Chewbacca" },
        { n: "CM-CR", name: "Chewbacca" },
        { n: "CM-JR", name: "Jawa" },
        { n: "CM-LC", name: "Luke Skywalker" },
        { n: "CM-LOR", name: "Princess Leia Organa" },
        { n: "CM-LR", name: "Luke Skywalker" },
        { n: "CM-LS", name: "Luke Skywalker" },
        { n: "CM-LV", name: "Luke Skywalker" },
        { n: "CM-OV", name: "Obi-Wan Kenobi" },
        { n: "CM-PLC", name: "Princess Leia Organa" },
        { n: "CM-PLV", name: "Princess Leia Organa" },
        { n: "CM-RC", name: "R2-D2" },
        { n: "CM-RR", name: "R2-D2" },
        { n: "CM-SS", name: "Stormtrooper" },
        { n: "CM-SV", name: "Stormtrooper" },
        { n: "CM-VS", name: "Darth Vader" },
        { n: "CM-VV", name: "Darth Vader" },
        { n: "CM-WC", name: "Wicket W. Warrick" },
    ],
  },
  {
    id: "jumbo-costume-relics",
    type: "insert",
    title: "JUMBO COSTUME RELICS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 25, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "JCR-AT", name: "Ahsoka Tano Shirt Lining" },
        { n: "JCR-BE", name: "Tobias Beckett Trench Coat" },
        { n: "JCR-BF", name: "Boba Fett Pants" },
        { n: "JCR-BR", name: "Bodhi Rook Imperial Jumpsuit" },
        { n: "JCR-FN", name: "Finn Imperial Disguise Tunic" },
        { n: "JCR-GE", name: "Galen Erso Farmer Disguise Jacket" },
        { n: "JCR-GG", name: "Gamorrean Fighter Leather Shirt" },
        { n: "JCR-GM", name: "General Merrick Mae West Jacket" },
        { n: "JCR-JE", name: "Jyn Erso Poncho" },
        { n: "JCR-LS", name: "Luke Skywalker Battle Tunic" },
        { n: "JCR-LU", name: "Luke Skywalker Pants" },
        { n: "JCR-MC", name: "The Mandalorian Cloak" },
        { n: "JCR-PD", name: "Poe Dameron Jacket" },
        { n: "JCR-PO", name: "Poe Dameron Shirt" },
        { n: "JCR-QI", name: "Qi'ra Leggings" },
        { n: "JCR-RE", name: "Rey Jacket" },
        { n: "JCR-TMA", name: "The Mandalorian Vest" },
    ],
  },
  {
    id: "lucasfilm-50th-anniversary",
    type: "insert",
    title: "LUCASFILM 50TH ANNIVERSARY",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "LFA-1", name: "George Lucas creates Lucasfilm" },
        { n: "LFA-2", name: "Star Wars: A New Hope" },
        { n: "LFA-3", name: "Star Wars: The Empire Strikes Back" },
        { n: "LFA-4", name: "Star Wars: Return of the Jedi" },
        { n: "LFA-5", name: "Star Wars: The Phantom Menace" },
        { n: "LFA-6", name: "Star Wars: Attack of the Clones" },
        { n: "LFA-7", name: "Star Wars: Revenge of the Sith" },
        { n: "LFA-8", name: "Star Wars: The Force Awakens" },
        { n: "LFA-9", name: "Star Wars: The Last Jedi" },
        { n: "LFA-10", name: "Star Wars: The Rise of Skywalker" },
        { n: "LFA-11", name: "Spin-Offs and Animated Series" },
        { n: "LFA-12", name: "Star Wars: Galaxy's Edge" },
        { n: "LFA-13", name: "Disney+ launches with Star Wars films and The Mandalorian" },
        { n: "LFA-14", name: "The Book of Boba Fett announced" },
    ],
  },
  {
    id: "lucasfilm-50th-anniversary-gold-metal-variation",
    type: "insert",
    title: "LUCASFILM 50TH ANNIVERSARY GOLD METAL VARIATION",
    parallels: [
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "LFA-1GM", name: "George Lucas creates Lucasfilm" },
        { n: "LFA-2GM", name: "Star Wars: A New Hope" },
        { n: "LFA-3GM", name: "Star Wars: The Empire Strikes Back" },
        { n: "LFA-4GM", name: "Star Wars: Return of the Jedi" },
        { n: "LFA-5GM", name: "Star Wars: The Phantom Menace" },
        { n: "LFA-6GM", name: "Star Wars: Attack of the Clones" },
        { n: "LFA-7GM", name: "Star Wars: Revenge of the Sith" },
        { n: "LFA-8GM", name: "Star Wars: The Force Awakens" },
        { n: "LFA-9GM", name: "Star Wars: The Last Jedi" },
        { n: "LFA-10GM", name: "Star Wars: The Rise of Skywalker" },
        { n: "LFA-11GM", name: "Spin-Offs and Animated Series" },
        { n: "LFA-12GM", name: "Star Wars: Galaxy's Edge" },
        { n: "LFA-13GM", name: "Disney+ launches with Star Wars films and The Mandalorian" },
        { n: "LFA-14GM", name: "The Book of Boba Fett announced" },
    ],
  },
  {
    id: "lucasfilm-50th-anniversary-metal-variation",
    type: "insert",
    title: "LUCASFILM 50TH ANNIVERSARY METAL VARIATION",
    parallels: [
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
      ],
    cards: [
        { n: "LFA-1M", name: "George Lucas creates Lucasfilm" },
        { n: "LFA-2M", name: "Star Wars: A New Hope" },
        { n: "LFA-3M", name: "Star Wars: The Empire Strikes Back" },
        { n: "LFA-4M", name: "Star Wars: Return of the Jedi" },
        { n: "LFA-5M", name: "Star Wars: The Phantom Menace" },
        { n: "LFA-6M", name: "Star Wars: Attack of the Clones" },
        { n: "LFA-7M", name: "Star Wars: Revenge of the Sith" },
        { n: "LFA-8M", name: "Star Wars: The Force Awakens" },
        { n: "LFA-9M", name: "Star Wars: The Last Jedi" },
        { n: "LFA-10M", name: "Star Wars: The Rise of Skywalker" },
        { n: "LFA-11M", name: "Spin-Offs and Animated Series" },
        { n: "LFA-12M", name: "Star Wars: Galaxy's Edge" },
        { n: "LFA-13M", name: "Disney+ launches with Star Wars films and The Mandalorian" },
        { n: "LFA-14M", name: "The Book of Boba Fett announced" },
    ],
  },
  {
    id: "out-of-the-box",
    type: "insert",
    title: "OUT OF THE BOX",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "OTB-1", name: "Obi-Wan Kenobi" },
        { n: "OTB-2", name: "Han Solo" },
        { n: "OTB-3", name: "Luke Skywalker" },
        { n: "OTB-4", name: "Princess Leia Organa" },
        { n: "OTB-5", name: "Princess Leia Organa" },
        { n: "OTB-6", name: "Han Solo" },
        { n: "OTB-7", name: "C-3PO" },
        { n: "OTB-8", name: "R2-D2" },
        { n: "OTB-9", name: "Chewbacca" },
        { n: "OTB-10", name: "Greedo" },
        { n: "OTB-11", name: "Darth Vader" },
        { n: "OTB-12", name: "Boba Fett" },
        { n: "OTB-13", name: "Lando Calrissian" },
        { n: "OTB-14", name: "Tusken Raider" },
        { n: "OTB-15", name: "Rancor" },
        { n: "OTB-16", name: "Ewok" },
        { n: "OTB-17", name: "Stormtrooper" },
        { n: "OTB-18", name: "Biker Scout" },
        { n: "OTB-19", name: "Snowtrooper" },
        { n: "OTB-20", name: "Admiral Ackbar" },
        { n: "OTB-21", name: "Gamorrean Guard" },
        { n: "OTB-22", name: "Jawa" },
        { n: "OTB-23", name: "R2-D2" },
        { n: "OTB-24", name: "Tie Fighter Pilot" },
        { n: "OTB-25", name: "Emperor's Royal Guard" },
    ],
  },
  {
    id: "out-of-the-box-gold-metal-variation",
    type: "insert",
    title: "OUT OF THE BOX GOLD METAL VARIATION",
    parallels: [
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "OTB-1GM", name: "Obi-Wan Kenobi" },
        { n: "OTB-2GM", name: "Han Solo" },
        { n: "OTB-3GM", name: "Luke Skywalker" },
        { n: "OTB-4GM", name: "Princess Leia Organa" },
        { n: "OTB-5GM", name: "Princess Leia Organa" },
        { n: "OTB-6GM", name: "Han Solo" },
        { n: "OTB-7GM", name: "C-3PO" },
        { n: "OTB-8GM", name: "R2-D2" },
        { n: "OTB-9GM", name: "Chewbacca" },
        { n: "OTB-10GM", name: "Greedo" },
        { n: "OTB-11GM", name: "Darth Vader" },
        { n: "OTB-12GM", name: "Boba Fett" },
        { n: "OTB-13GM", name: "Lando Calrissian" },
        { n: "OTB-14GM", name: "Tusken Raider" },
        { n: "OTB-15GM", name: "Rancor" },
        { n: "OTB-16GM", name: "Ewok" },
        { n: "OTB-17GM", name: "Stormtrooper" },
        { n: "OTB-18GM", name: "Biker Scout" },
        { n: "OTB-19GM", name: "Snowtrooper" },
        { n: "OTB-20GM", name: "Admiral Ackbar" },
        { n: "OTB-21GM", name: "Gamorrean Guard" },
        { n: "OTB-22GM", name: "Jawa" },
        { n: "OTB-23GM", name: "R2-D2" },
        { n: "OTB-24GM", name: "Tie Fighter Pilot" },
        { n: "OTB-25GM", name: "Emperor's Royal Guard" },
    ],
  },
  {
    id: "out-of-the-box-metal-variation",
    type: "insert",
    title: "OUT OF THE BOX METAL VARIATION",
    parallels: [
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
      ],
    cards: [
        { n: "OTB-1M", name: "Obi-Wan Kenobi" },
        { n: "OTB-2M", name: "Han Solo" },
        { n: "OTB-3M", name: "Luke Skywalker" },
        { n: "OTB-4M", name: "Princess Leia Organa" },
        { n: "OTB-5M", name: "Princess Leia Organa" },
        { n: "OTB-6M", name: "Han Solo" },
        { n: "OTB-7M", name: "C-3PO" },
        { n: "OTB-8M", name: "R2-D2" },
        { n: "OTB-9M", name: "Chewbacca" },
        { n: "OTB-10M", name: "Greedo" },
        { n: "OTB-11M", name: "Darth Vader" },
        { n: "OTB-12M", name: "Boba Fett" },
        { n: "OTB-13M", name: "Lando Calrissian" },
        { n: "OTB-14M", name: "Tusken Raider" },
        { n: "OTB-15M", name: "Rancor" },
        { n: "OTB-16M", name: "Ewok" },
        { n: "OTB-17M", name: "Stormtrooper" },
        { n: "OTB-18M", name: "Biker Scout" },
        { n: "OTB-19M", name: "Snowtrooper" },
        { n: "OTB-20M", name: "Admiral Ackbar" },
        { n: "OTB-21M", name: "Gamorrean Guard" },
        { n: "OTB-22M", name: "Jawa" },
        { n: "OTB-23M", name: "R2-D2" },
        { n: "OTB-24M", name: "Tie Fighter Pilot" },
        { n: "OTB-25M", name: "Emperor's Royal Guard" },
    ],
  },
  {
    id: "stamp-cards",
    type: "insert",
    title: "STAMP CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SC-AG", name: "Adi Gallia" },
        { n: "SC-AN", name: "Anakin Skywalker" },
        { n: "SC-AS", name: "Anakin Skywalker" },
        { n: "SC-BB", name: "BB-8" },
        { n: "SC-CHW", name: "Chewbacca" },
        { n: "SC-FB", name: "Fode and Beed" },
        { n: "SC-FN", name: "Finn" },
        { n: "SC-JA", name: "Jannah" },
        { n: "SC-KF", name: "Kit Fisto" },
        { n: "SC-KR", name: "Kylo Ren" },
        { n: "SC-LO", name: "Leia Organa" },
        { n: "SC-LS", name: "Luke Skywalker" },
        { n: "SC-PD", name: "Poe Dameron" },
        { n: "SC-PDA", name: "Poe Dameron" },
        { n: "SC-QG", name: "Qui Gon Jin" },
        { n: "SC-R2", name: "R2-D2" },
        { n: "SC-SE", name: "Sebulba" },
        { n: "SC-ST", name: "Stormtrooper" },
        { n: "SC-STI", name: "Saesee Tiin" },
        { n: "SC-STP", name: "Scout Trooper" },
        { n: "SC-SW", name: "Snap Wexley" },
        { n: "SC-TA", name: "Tallie Lintra" },
        { n: "SC-WA", name: "Watto" },
        { n: "SC-WW", name: "Wicket W Warrick" },
    ],
  },
  {
    id: "welcome-to-the-dark-side",
    type: "insert",
    title: "WELCOME TO THE DARK SIDE",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "WDS-1", name: "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-2", name: "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)" },
        { n: "WDS-3", name: "\"I am your father.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-4", name: "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-5", name: "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-6", name: "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)" },
        { n: "WDS-7", name: "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)" },
        { n: "WDS-8", name: "\"The Force is strong in this one.\" (Star Wars: A New Hope)" },
        { n: "WDS-9", name: "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-10", name: "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)" },
    ],
  },
  {
    id: "welcome-to-the-dark-side-gold-metal-variation",
    type: "insert",
    title: "WELCOME TO THE DARK SIDE GOLD METAL VARIATION",
    parallels: [
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "WDS-1GM", name: "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-2GM", name: "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)" },
        { n: "WDS-3GM", name: "\"I am your father.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-4GM", name: "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-5GM", name: "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-6GM", name: "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)" },
        { n: "WDS-7GM", name: "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)" },
        { n: "WDS-8GM", name: "\"The Force is strong in this one.\" (Star Wars: A New Hope)" },
        { n: "WDS-9GM", name: "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-10GM", name: "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)" },
    ],
  },
  {
    id: "welcome-to-the-dark-side-metal-variation",
    type: "insert",
    title: "WELCOME TO THE DARK SIDE METAL VARIATION",
    parallels: [
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
      ],
    cards: [
        { n: "WDS-1M", name: "\"You don't know the power of the dark side.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-2M", name: "\"When I left you, I was but the learner. Now I am the master.\" (Star Wars: A New Hope)" },
        { n: "WDS-3M", name: "\"I am your father.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-4M", name: "\"I am altering the deal. Pray I don't alter it any further.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-5M", name: "\"Your destiny lies with me, Skywalker.\" (Star Wars: The Empire Strikes Back)" },
        { n: "WDS-6M", name: "\"Be careful not to choke on your aspirations.\" (Rogue One: A Star Wars Story)" },
        { n: "WDS-7M", name: "\"I find your lack of faith disturbing.\" (Star Wars: A New Hope)" },
        { n: "WDS-8M", name: "\"The Force is strong in this one.\" (Star Wars: A New Hope)" },
        { n: "WDS-9M", name: "\"If you will not turn to the dark side, then perhaps she will.\" (Star Wars: Return of the Jedi)" },
        { n: "WDS-10M", name: "\"The Emperor will show you the true nature of the Force.\" (Star Wars: Return of the Jedi)" },
    ],
  },
  {
    id: "galactic-autograph-book",
    type: "auto",
    title: "GALACTIC AUTOGRAPH BOOK",
    parallels: [
        // Rule-7 check resolved: the 20-signer book is a single 1/1
        // (Cardboard Connection × Cardsmiths agree) — this slot is correct.
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "GAB-2021", name: "Andy Serkis / Carl Weathers / Pedro Pascal / Billy Dee Williams / Gwendoline Christie / John Boyega / Ian McDiarmid / Adam Driver / Daisy Ridley / Harrison Ford / David Prowse / Ewan McGregor / Samuel L. Jackson / Hayden Christensen / Mads Mikkelsen / Felicity Jones / Carrie Fisher / Alden Ehrenreich / Emilia Clarke / Natalie Portman as Supreme Leader Snoke / Greef Karga / The Mandalorian / Lando Calrissian / Captain Phasma / Finn / Emperor Palpatine / Kylo Ren / Rey / Han Solo / Darth Vader / Obi-Wan Kenobi / Mace Windu / Anakin Skywalker / Galen Erso / Jyn Erso / Princess Leia Organa / Han Solo / Qi'ra / Queen Amidala" },
    ],
  },
  {
    id: "on-card-autographs",
    type: "auto",
    title: "ON CARD AUTOGRAPHS",
    parallels: [
        // Rule-7 check resolved: base autographs are NOT serial numbered —
        // Cardboard Connection × Beckett both start the ladder at Blue Foil /99.
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-AB", name: "Ahmed Best as Jar Jar Binks" },
        { n: "MWA-ABR", name: "Anna Brewster as Bazine Netal" },
        { n: "MWA-AD", name: "Adam Driver as Kylo Ren" },
        { n: "MWA-ADA", name: "Annabelle Davis as Thromba" },
        { n: "MWA-AE", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "MWA-AL", name: "Amanda Lawrence as Commander D'Acy" },
        { n: "MWA-AS", name: "Amy Sedaris as Peli Motto" },
        { n: "MWA-AW", name: "Alexander Wraith as Imperial Freighter Pilot" },
        { n: "MWA-BH", name: "Brian Herring as BB-8" },
        { n: "MWA-CB", name: "Chris Bartlett as Teacher Droid" },
        { n: "MWA-CE", name: "Chris Edgerly as Eeth Koth" },
        { n: "MWA-CG", name: "Clare Grant as Latts Razzi" },
        { n: "MWA-DBC", name: "Dee Bradley Baker as Crosshair" },
        { n: "MWA-DBE", name: "Dee Bradley Baker as Echo" },
        { n: "MWA-DBH", name: "Dee Bradley Baker as Hunter" },
        { n: "MWA-DBR", name: "Dee Bradley Baker as Captain Rex" },
        { n: "MWA-DBT", name: "Dee Bradley Baker as Tech" },
        { n: "MWA-DBW", name: "Dee Bradley Baker as Wrecker" },
        { n: "MWA-DI", name: "Diana Lee Inosanto as Magistrate Morgan Elsbeth" },
        { n: "MWA-DR", name: "Daisy Ridley as Rey" },
        { n: "MWA-EC", name: "Emilia Clarke as Qi'ra" },
        { n: "MWA-ES", name: "Emily Swallow as The Armorer" },
        { n: "MWA-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "MWA-GG", name: "Greg Grunberg as Snap Wexley" },
        { n: "MWA-HC", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "MWA-IM", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "MWA-JG", name: "Janina Gavankar as Iden Versio" },
        { n: "MWA-JL", name: "John Leguizamo as Gor Koresh" },
        { n: "MWA-KO", name: "Katy O'Brian as Imperial Comms Officer" },
        { n: "MWA-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "MWA-LS", name: "Leilani Shiu as Jawa" },
        { n: "MWA-MBO", name: "Mark Boone Junior as Ranzar Malk" },
        { n: "MWA-MIB", name: "Michonne Bourriague as Aurra Sing" },
        { n: "MWA-MM", name: "Mary Elizabeth McGlynn as Governor Arihnda Pryce" },
        { n: "MWA-MV", name: "Mercedes Varnado as Koska Reeves" },
        { n: "MWA-MW", name: "Matthew Wood as General Grievous" },
        { n: "MWA-NF", name: "Nika Futterman as Asajj Ventress" },
        { n: "MWA-NP", name: "Natalie Portman as Queen Amidala" },
        { n: "MWA-OA", name: "Omid Abtahi as Dr. Pershing" },
        { n: "MWA-PA", name: "Philip Anthony-Rodriguez as Fifth Brother" },
        { n: "MWA-PAL", name: "Philip Alexander as Imperial Security Officer" },
        { n: "MWA-PK", name: "Paul Kasey as C'ai Threnalli" },
        { n: "MWA-PL", name: "Paul Sun-Hyung Lee as Captain Carson Teva" },
        { n: "MWA-RB", name: "Richard Brake as Valin Hess" },
        { n: "MWA-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "MWA-RG", name: "Richard Grant as Allegiant General Pryde" },
        { n: "MWA-RO", name: "Rena Owen as Taun We" },
        { n: "MWA-SK", name: "Simon Kassianides as Axe Woves" },
        { n: "MWA-SS", name: "Stephen Stanton as Admiral Tarkin" },
        { n: "MWA-SW", name: "Sam Witwer as Darth Maul" },
        { n: "MWA-TG", name: "Taylor Gray as Ezra Bridger" },
        { n: "MWA-TR", name: "Tim Rose as Admiral Ackbar" },
    ],
  },
  {
    id: "dual-autograph-cards",
    type: "auto",
    title: "DUAL AUTOGRAPH CARDS",
    parallels: [
        // Base card is serial-numbered /50 (Cardboard Connection × Beckett agree).
        { id: "base", name: "", print_run: 50, color: "#c8d8f0" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWD-BM", name: "Mary Elizabeth McGlynn / Steve Blum as Governor Arihnda Pryce / Zeb Orrelios" },
        { n: "MWD-CE", name: "Alden Ehrenreich / Emilia Clarke as Han Solo / Qi'ra" },
        { n: "MWD-CP", name: "Natalie Portman / Hayden Christensen as Padmé Amidala / Anakin Skywalker" },
        { n: "MWD-DC", name: "Adam Driver / Gwendoline Christie as Kylo Ren / Captain Phasma" },
        { n: "MWD-DI", name: "Diana Lee Inosanto / Rosario Dawson as Magistrate Morgan Elsbeth / Ahsoka Tano" },
        { n: "MWD-HA", name: "Werner Herzog / Omid Abtahi as The Client / Dr. Pershing" },
        { n: "MWD-HR", name: "Ralph Brown / Hugh Quarshie as Ric Olié / Captain Panaka" },
        { n: "MWD-JM", name: "Ben Mendelsohn / Felicity Jones as Director Krennic / Jyn Erso" },
        { n: "MWD-MB", name: "Temuera Morrison / Jeremy Bulloch as Jango Fett / Boba Fett" },
        { n: "MWD-MC", name: "Ewan McGregor / Hayden Christensen as Obi-Wan Kenobi / Anakin Skywalker" },
        { n: "MWD-MG", name: "Taylor Gray / Lars Mikkelsen as Ezra Bridger / Grand Admiral Thrawn" },
        { n: "MWD-RM", name: "Daisy Ridley / Ian McDiarmid as Rey / Emperor Palpatine" },
        { n: "MWD-SW", name: "Nick Nolte / Carl Weathers as Kuiil / Greef Karga" },
        { n: "MWD-WB", name: "Dickey Beer / Corey Dee Williams as Barada / Klaatu" },
        { n: "MWD-WG", name: "Matthew Wood / Kathleen Gati as General Grievous / Old Daka" },
    ],
  },
  {
    id: "quad-autograph-book-cards",
    type: "auto",
    title: "QUAD AUTOGRAPH BOOK CARDS",
    parallels: [
        // Base card is serial-numbered /2 — two copies of each book
        // (Cardboard Connection × Beckett × Cardsmiths agree).
        { id: "one-of-one", name: "", print_run: 2, color: "#c8d8f0" },
      ],
    cards: [
        { n: "MWQ-MBSP", name: "Riz Ahmed / Donnie Yen / Alan Tudyk / Felicity Jones as Bodhi Rook / Chirrut Îmwe / K-2SO / Jyn Erso" },
        { n: "MWQ-MPCD", name: "Hayden Christensen / Ray Park / Ian McDiarmid / Adam Driver as Darth Vader / Darth Maul / Emperor Palpatine / Kylo Ren" },
        { n: "MWQ-MWWN", name: "David Barclay / Michael Carter / Mark Dodson / Jeremy Bulloch as Jabba The Hutt / Bib Fortuna / Salacious B. Crumb / Boba Fett" },
        { n: "MWQ-PJFR", name: "Natalie Portman / Felicity Jones / Carrie Fisher / Daisy Ridley as Queen Amidala / Jyn Erso / Princess Leia Organa / Rey" },
    ],
  },
  {
    id: "triple-autograph-cards",
    type: "auto",
    title: "TRIPLE AUTOGRAPH CARDS",
    parallels: [
        // Base card is serial-numbered /25 (Cardboard Connection × Beckett agree).
        { id: "base", name: "", print_run: 25, color: "#c8d8f0" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWT-BMT", name: "John Boyega / Kelly Marie Tran / Dominic Monaghan as Finn / Rose Tico / Beaumont Kin" },
        { n: "MWT-CFD", name: "Harrison Ford / Adam Driver / Andy Serkis as Han Solo / Kylo Ren / Supreme Leader Snoke" },
        { n: "MWT-CPF", name: "Natalie Portman / Hayden Christensen / Ian McDiarmid as Padmé Amidala / Anakin Skywalker / Supreme Chancellor Palpatine" },
        { n: "MWT-EBC", name: "Emilia Clarke / Paul Bettany / Alden Ehrenreich as Qi'ra / Dryden Vos / Han Solo" },
        { n: "MWT-GBS", name: "Steve Blum / Taylor Gray / Tiya Sircar as Zeb Orrelios / Ezra Bridger / Sabine Wren" },
        { n: "MWT-MPC", name: "Ray Park / Ian McDiarmid / Hayden Christensen as Darth Maul / Emperor Palpatine / Darth Vader" },
    ],
  },
  {
    id: "pen-relic-autographs",
    type: "auto",
    title: "PEN RELIC AUTOGRAPHS",
    parallels: [
        // Rule-7 check resolved: kept as 1/1 — no source publishes a print run,
        // but pen relics are 1/1 across the Masterwork line (2022 confirmed);
        // no specimen check was done, so confidence is high but not 100%.
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PRA-AB", name: "Ahmed Best as Jar Jar Binks" },
        { n: "PRA-ABR", name: "Anna Brewster as Bazine Netal" },
        { n: "PRA-AD", name: "Adam Driver as Kylo Ren" },
        { n: "PRA-ADA", name: "Annabelle Davis as Thromba" },
        { n: "PRA-AE", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "PRA-AL", name: "Amanda Lawrence as Commander D'Acy" },
        { n: "PRA-BD", name: "Ben Daniels as General Merrick" },
        { n: "PRA-BH", name: "Brian Herring as BB-8" },
        { n: "PRA-BL", name: "Billie Lourd as Kaydel Ko Connix" },
        { n: "PRA-CW", name: "Carl Weathers as Greef Karga" },
        { n: "PRA-DBC", name: "Dee Bradley Baker as Crosshair" },
        { n: "PRA-DBE", name: "Dee Bradley Baker as Echo" },
        { n: "PRA-DBH", name: "Dee Bradley Baker as Hunter" },
        { n: "PRA-DBR", name: "Dee Bradley Baker as Captain Rex" },
        { n: "PRA-DBT", name: "Dee Bradley Baker as Tech" },
        { n: "PRA-DBW", name: "Dee Bradley Baker as Wrecker" },
        { n: "PRA-DI", name: "Diana Lee Inosanto as Magistrate Morgan Elsbeth" },
        { n: "PRA-DL", name: "Daniel Logan as Boba Fett" },
        { n: "PRA-DR", name: "Daisy Ridley as Rey" },
        { n: "PRA-EC", name: "Emilia Clarke as Qi'ra" },
        { n: "PRA-ES", name: "Emily Swallow as The Armorer" },
        { n: "PRA-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "PRA-GG", name: "Greg Grunberg as Snap Wexley" },
        { n: "PRA-HC", name: "Hayden Christensen as Anakin Skywalker" },
        { n: "PRA-IM", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "PRA-JL", name: "John Leguizamo as Gor Koresh" },
        { n: "PRA-JT", name: "James Arnold Taylor as Obi-Wan Kenobi" },
        { n: "PRA-KO", name: "Katy O'Brian as Comms Officer" },
        { n: "PRA-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
        { n: "PRA-MBO", name: "Mark Boone Junior as Ranzar Malk" },
        { n: "PRA-MM", name: "Mary Elizabeth McGlynn as Governor Arihnda Pryce" },
        { n: "PRA-MW", name: "Matthew Wood as General Grievous" },
        { n: "PRA-NP", name: "Natalie Portman as Queen Amidala" },
        { n: "PRA-OA", name: "Omid Abtahi as Dr. Pershing" },
        { n: "PRA-PK", name: "Paul Kasey as Ello Asty" },
        { n: "PRA-PL", name: "Paul Sun-Hyung Lee as Captain Carson Teva" },
        { n: "PRA-RB", name: "Richard Brake as Valin Hess" },
        { n: "PRA-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "PRA-RO", name: "Rena Owen as Taun We" },
        { n: "PRA-SK", name: "Simon Kassianides as Axe Woves" },
        { n: "PRA-SS", name: "Stephen Stanton as Admiral Tarkin" },
        { n: "PRA-TG", name: "Taylor Gray as Ezra Bridger" },
        { n: "PRA-TM", name: "Temuera Morrison as Boba Fett" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
